import type { TFunction } from 'i18next';
import { isFlagGlossaryEntryVisible } from './flagGlossary.config';
import type {
  FlagGlossaryEntry,
  FlagGlossaryKpiCounts,
  FlagGlossaryRowView,
} from './flagGlossary.types';
import {
  buildFlagGlossaryCategoryOptions,
  type FlagGlossaryCategoryOption,
} from './flagGlossaryFiltering';
import { computeFlagGlossaryKpiCounts } from './flagGlossaryKpiCounts';
import { mapFlagGlossaryRows } from './mapFlagGlossaryRow';

/**
 * Filter-independent glossary derivations, computed once per `entries`/`t`.
 * Filtered rows depend on the active filters and are derived separately with
 * {@link filterFlagGlossaryRows} so this stays stable across filter changes.
 */
export type FlagGlossaryBaseState = {
  allRows: FlagGlossaryRowView[];
  categoryOptions: FlagGlossaryCategoryOption[];
  kpiCounts: FlagGlossaryKpiCounts;
};

export const buildFlagGlossaryBaseState = (
  entries: FlagGlossaryEntry[],
  t: TFunction,
): FlagGlossaryBaseState => {
  const visibleEntries = entries.filter((entry) =>
    isFlagGlossaryEntryVisible(entry.flagType),
  );
  const allRows = mapFlagGlossaryRows(visibleEntries, t);
  return {
    allRows,
    categoryOptions: buildFlagGlossaryCategoryOptions(allRows),
    kpiCounts: computeFlagGlossaryKpiCounts(visibleEntries),
  };
};
